import { WorkflowMessage } from 'interfaces-lib';
import { IFile } from 'interfaces-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { WorkflowTask } from 'workflow-task-service-lib';
import { IRunParams } from '../services/ai-prompt.service';
import { IBullhornCardContext } from '../types/bullhorn-card-context';
import { IMessageHandlerComponent } from '../types/component-method-message-handler';
import { IEntitySourceData } from '../types/IEntitySourceData';
import { IStartParameters } from '../types/IStartParameters';
import { IPromptProfile } from '../types/prompt-profile';

export class AiResponseTask extends WorkflowTask {
  constructor(
    private sourceDataV7: IEntitySourceData[],
    private promptProfile: IPromptProfile,
    private runParams: IRunParams,
    private sourceFiles: IFile[],
    private fileDataOnly: boolean,
    private sourceNotes: IEntitySourceData[],
    private cardContext: IBullhornCardContext,
    private messageNotificationService: MessageNotificationService,
    private component: IMessageHandlerComponent
  ) {
    super('AI_ASSIST_REQUEST');
  }

  override getStartParams(): any {
    // TODO refactor this to be cleaner
    let startParams: IStartParameters = {
      promptProfile: { ...this.promptProfile },
      runParams: { ...this.runParams },
    };

    // for tiny mce primpt
    // change name from code to manipulate
    if (this.promptProfile.promptType === 'AI_ADDON_PROMPT' && this.promptProfile.description) {
      startParams.entitySourceDataV7 = [{
        id: 'user-input-text',
        sourcePathCommand: { namespace: 'user-input-text', path: ['content'] },
        fields: this.promptProfile.description
      }];
    } else if (!this.fileDataOnly) {
      startParams.entitySourceDataV7 = this.sourceDataV7;
      if (this.sourceNotes && this.sourceNotes.length !== 0) {
        startParams.sourceNotes = this.sourceNotes;
      }
    }
    if (this.sourceFiles.length > 0) {
      this.sourceFiles = this.sourceFiles.map((file) => {
        return this.mapSourceFileToFile('bullhorn', file, this.cardContext);
      });
      startParams.sourceFiles = this.sourceFiles;
    }
    return startParams;
  }

  override receive(message: WorkflowMessage): boolean {
    if (message.type === MESSAGE_TYPE.ERROR_EVENT) {
      this.component.handleError(message);
      return true;
    }

    if (message.type === MESSAGE_TYPE.AI_SERVICE_STATUS) {
      this.component.handleMessage(message);
      return false;
    }

    if (message.type === MESSAGE_TYPE.AI_SERVICE_RESPONSE) {
      this.component.handleMessage(message);
      return true;
    }

    console.debug(`Message '${message.type}' not handled.`);

    return false;
  }

  private mapSourceFileToFile(
    namespace: string,
    file: IFile,
    bullhornCardContext: IBullhornCardContext
  ): any {
    return {
      // TODO need to make namespace generic
      namespace: namespace,
      path: [bullhornCardContext.cardEntityType, bullhornCardContext.cardEntityId, file.id],
    };
  }
}

export enum MESSAGE_TYPE {
  ERROR_EVENT = 'ErrorEvent',
  AI_SERVICE_STATUS = 'AiServiceStatus',
  AI_SERVICE_RESPONSE = 'AiServiceResponse',
}
